import { render, staticRenderFns } from "./NonSatsangiEntry.vue?vue&type=template&id=312123b5&"
import script from "./NonSatsangiEntry.vue?vue&type=script&lang=js&"
export * from "./NonSatsangiEntry.vue?vue&type=script&lang=js&"
import style0 from "./NonSatsangiEntry.vue?vue&type=style&index=0&media=screen&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports